import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "astreinte-container" }
const _hoisted_2 = { class: "titre-container" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('modale.jour.ferie.titre')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.societesJourFerie, (societeAstreinte) => {
          return (_openBlock(), _createElementBlock("div", {
            key: societeAstreinte.societe
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(societeAstreinte.societe), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(societeAstreinte.telephone), 1)
          ]))
        }), 128)),
        _createElementVNode("img", {
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          src: _ctx.closeIcon,
          alt: "close"
        }, null, 8, _hoisted_5)
      ])
    ]),
    _: 1
  }))
}